import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Input } from "@/components/ui/input";
import { useState } from "react";

interface PaymentMethodSelectorProps {
  selectedMethod: string;
  onMethodChange: (method: string) => void;
}

export const PaymentMethodSelector = ({
  selectedMethod,
  onMethodChange,
}: PaymentMethodSelectorProps) => {
  const [customMethod, setCustomMethod] = useState("");

  const handleCustomMethodChange = (value: string) => {
    setCustomMethod(value);
    if (value) {
      onMethodChange(value);
    }
  };

  return (
    <div className="space-y-2">
      <Label>Mode de paiement (obligatoire)</Label>
      <RadioGroup
        value={selectedMethod}
        onValueChange={onMethodChange}
        className="flex flex-col space-y-1"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="cash" id="cash" />
          <Label htmlFor="cash">Espèces</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="bank_transfer" id="bank_transfer" />
          <Label htmlFor="bank_transfer">Virement bancaire</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="wave" id="wave" />
          <Label htmlFor="wave">Wave</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="orange_money" id="orange_money" />
          <Label htmlFor="orange_money">Orange Money</Label>
        </div>
        {selectedMethod === "custom" && (
          <div className="ml-6 mt-2">
            <Input
              type="text"
              placeholder="Précisez le mode de paiement"
              value={customMethod}
              onChange={(e) => handleCustomMethodChange(e.target.value)}
              className="max-w-xs"
            />
          </div>
        )}
      </RadioGroup>
    </div>
  );
};